import React from "react";
import Navbar from "../../components/Navbar";
import AssetAgnosticism from "../../components/HomePage Components/AssetAgnosticism";
import BusinessMeaning from "../../components/HomePage Components/BusinessMeaning";
import Work from "../../components/HomePage Components/Work";
import Product from "../../components/HomePage Components/Product";
import Advantages from "../../components/HomePage Components/Advantages";
import GetStarted from "../../components/HomePage Components/GetStarted";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: "var(--c-bg)", minHeight: "100vh" }}>
      <Navbar />

      {/* HERO */}
      <section
        className="relative min-h-screen flex items-center overflow-hidden grid-bg"
        style={{ paddingTop: "80px" }}
      >
        {/* Radial glow */}
        <div
          className="absolute"
          style={{
            top: "20%", left: "50%", transform: "translateX(-50%)",
            width: "800px", height: "600px",
            background: "radial-gradient(ellipse, rgba(82,198,168,0.08) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />
        {/* Floating orb right */}
        <div
          className="float absolute right-0 top-1/2"
          style={{
            width: "480px", height: "480px",
            background: "radial-gradient(circle, rgba(79,142,247,0.12) 0%, transparent 70%)",
            transform: "translateY(-50%)",
            pointerEvents: "none",
          }}
        />

        <div className="relative z-10 max-w-7xl mx-auto px-8 w-full">
          <div className="flex flex-col lg:flex-row items-center gap-16 py-20">
            {/* Left */}
            <div className="flex-1 space-y-8">
              <div className="badge anim-1">
                <span className="badge-dot"></span>
                Advanced Payment Gateway
              </div>

              <h1
                className="font-syne font-bold leading-[1.05] anim-2"
                style={{ fontSize: "clamp(42px, 6vw, 84px)", color: "#e8eaf0" }}
              >
                The Future of{" "}
                <span className="grad-text">Financial</span>
                <br />Interoperability
              </h1>

              <p
                className="text-lg leading-relaxed anim-3"
                style={{ color: "var(--c-muted)", maxWidth: "520px", fontFamily: "'DM Sans', sans-serif" }}
              >
                Cahex bridges fiat and crypto seamlessly — accept TRON, BTC, USDT, and traditional card payments through a single, compliant gateway.
              </p>

              <div className="flex items-center gap-4 anim-4">
                <button
                  onClick={() => navigate("/merchant/signin")}
                  className="px-7 py-3.5 rounded-full font-syne font-semibold text-sm transition-all duration-300"
                  style={{
                    background: "linear-gradient(135deg, #52c6a8, #4f8ef7)",
                    color: "#06080f",
                    boxShadow: "0 0 30px rgba(82,198,168,0.3)",
                  }}
                  onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 0 50px rgba(82,198,168,0.55)"; }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow = "0 0 30px rgba(82,198,168,0.3)"; }}
                >
                  Start for free →
                </button>
                <button
                  className="px-7 py-3.5 rounded-full font-syne font-semibold text-sm transition-all duration-300"
                  style={{
                    color: "#e8eaf0",
                    border: "1px solid rgba(255,255,255,0.1)",
                    background: "rgba(255,255,255,0.03)",
                  }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(82,198,168,0.4)"; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)"; }}
                >
                  View Docs
                </button>
              </div>

              {/* Stats */}
              <div className="flex items-center gap-8 pt-4 anim-5">
                {[["<0.1%", "Fees"], ["2s", "Settlement"], ["150+", "Countries"]].map(([val, label]) => (
                  <div key={label}>
                    <div className="font-syne font-bold text-2xl grad-text">{val}</div>
                    <div className="text-xs" style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}>{label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right — visual */}
            <div className="flex-1 flex justify-center items-center">
              <div
                className="float relative"
                style={{ width: "420px", height: "420px" }}
              >
                {/* Spinning ring */}
                <div
                  className="spin-slow absolute inset-0 rounded-full"
                  style={{ border: "1px dashed rgba(82,198,168,0.2)" }}
                />
                <div
                  className="spin-slow absolute"
                  style={{
                    inset: "20px", borderRadius: "50%",
                    border: "1px dashed rgba(79,142,247,0.15)",
                    animationDirection: "reverse",
                    animationDuration: "15s",
                  }}
                />
                {/* Center card */}
                <div
                  className="absolute inset-0 flex items-center justify-center"
                >
                  <div
                    className="glow-box rounded-2xl p-8 text-center"
                    style={{ background: "rgba(13,17,32,0.9)", width: "260px" }}
                  >
                    <div
                      className="w-16 h-16 rounded-2xl mx-auto mb-4 flex items-center justify-center font-syne font-bold text-2xl"
                      style={{
                        background: "linear-gradient(135deg, #52c6a8, #4f8ef7)",
                        color: "#06080f",
                        boxShadow: "0 0 30px rgba(82,198,168,0.4)",
                      }}
                    >
                      C
                    </div>
                    <div className="font-syne font-bold text-white text-lg mb-1">CAHEX</div>
                    <div className="text-xs mb-4" style={{ color: "var(--c-muted)" }}>Universal Liquidity Protocol</div>
                    <div className="grad-divider mb-4" />
                    <div className="flex justify-between text-xs" style={{ color: "var(--c-muted)" }}>
                      <span>Fiat ✓</span>
                      <span>Crypto ✓</span>
                      <span>TRC-20 ✓</span>
                    </div>
                  </div>
                </div>

                {/* Orbiting chips */}
                {[
                  { label: "USDT", angle: 40,  r: 190, col: "#52c6a8" },
                  { label: "BTC",  angle: 160, r: 190, col: "#f7931a" },
                  { label: "Fiat", angle: 270, r: 190, col: "#4f8ef7" },
                ].map(({ label, angle, r, col }) => {
                  const rad = (angle * Math.PI) / 180;
                  const x = 210 + r * Math.cos(rad) - 30;
                  const y = 210 + r * Math.sin(rad) - 16;
                  return (
                    <div
                      key={label}
                      className="absolute px-3 py-1.5 rounded-full text-xs font-syne font-bold"
                      style={{
                        left: x, top: y,
                        background: `rgba(${col === "#52c6a8" ? "82,198,168" : col === "#f7931a" ? "247,147,26" : "79,142,247"},0.12)`,
                        border: `1px solid ${col}40`,
                        color: col,
                        boxShadow: `0 0 12px ${col}30`,
                      }}
                    >
                      {label}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom fade */}
        <div
          className="absolute bottom-0 left-0 right-0 h-32"
          style={{ background: "linear-gradient(transparent, var(--c-bg))" }}
        />
      </section>

      {/* Sections */}
      <div className="relative z-10">
        <AssetAgnosticism />
        <BusinessMeaning />
        <Work />
        <Product />
        <Advantages />
        <GetStarted />
      </div>
    </div>
  );
};

export default HomePage;
